import ComponentRender from './SimpleComponentRender';

export default ComponentRender;
